// extracted by mini-css-extract-plugin
module.exports = {"Index":"IndexTemplate_Index__7qKK_","Index__PurchasesArea":"IndexTemplate_Index__PurchasesArea__ui4oP","Index__PurchasesContent":"IndexTemplate_Index__PurchasesContent__Lgi63"};